import { useState, useEffect } from "react";
import fridge from "./image/ref.jpeg";
import washer from "./image/wash.jpeg";
import ac from "./image/ac.jpeg";
import dishwasher from "./image/dsw.webp";
import dry from "./image/dry.jpeg";
import bgImage from "./image/appliances.avif";
import emergensy from './image/247.jpg';
import AOS from 'aos';
import 'aos/dist/aos.css';

const imgStyle = {
  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0,0,0,0.3)), url(${bgImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  color: 'white',
  textAlign: 'center',
  padding: '60px 20px',
};

const sectionStyle = {
  background: '#0b3d2e',
  color: '#d4af37',
  textAlign: 'center',
  padding: '10px',
  borderRadius: '8px',
};

const services = [
  {
    title: 'Refrigerator Repair',
    image: fridge,
    features: [
      'Not cooling or overcooling',
      'Strange noises',
      'Water leakage',
      'Compressor and thermostat issues',
    ],
  },
  {
    title: 'Washing Machine Repair',
    image: washer,
    features: [
      'Water not draining or spinning',
      'Electrical faults',
      'Noise or vibration issues',
      'Front & top load servicing',
    ],
  },
  {
    title: 'Dryer Repair',
    image: dry,
    features: [
      'Not heating or drying clothes',
      'Drum not spinning',
      'Unusual noises or vibrations',
      'Electrical or timer malfunctions',
    ],
  },
  {
    title: 'Air Conditioner Repair',
    image: ac,
    features: [
      'AC not cooling',
      'Gas refilling',
      'Remote & PCB issues',
      'Split & window AC servicing',
    ],
  },
  {
    title: 'Dishwasher Repair',
    image: dishwasher,
    features: [
      'Not cleaning dishes',
      'Water drainage problems',
      'Leaking water',
      'Motor and spray arm repair',
    ],
  },
  {
    title: 'Emergency Repair Services',
    image: emergensy,
    features: [
      'Urgent repair appointments',
      'On-call technicians',
      'Weekend & holiday support',
      'Fast response for critical issues',
    ],
  },
];

const faqs = [
  {
    question: 'What types of appliances do you repair?',
    answer: 'We repair refrigerators, washing machines, dryers, air conditioners, dishwashers, and more.',
  },
  {
    question: 'Do you offer emergency repair services?',
    answer: 'Yes, we provide 24/7 emergency repair services including weekends and holidays.',
  },
  {
    question: 'Are your technicians certified?',
    answer: 'Yes, all our technicians are trained, experienced, and certified to handle appliance repairs.',
  },
  {
    question: 'Do you use original spare parts?',
    answer: 'We use only genuine and high-quality spare parts to ensure long-lasting repairs.',
  },
  {
    question: 'How can I book a service?',
    answer: 'You can call us directly at 9199245536 or fill out our online contact form to book a service.',
  },
];

const HomeApplianceService = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);

  return (
    <div className="container-fluid py-5" style={imgStyle}>
      
      {/* Hero Section */}
      <div className="text-center mb-4">
        <h1 className="display-3 fw-bold" style={{color:'#d4af37'}}>🛠️ Reliable Home Appliance Repair Services</h1>
        <p className="lead mt-3">
          Is your refrigerator, washing machine, or AC not working properly? We're here to help!
          With certified technicians and fast service, we bring your home back to comfort.
        </p>
        <a href="/contact" className="btn btn-lg btn-primary mt-3">Book a Service</a>
      </div>

      {/* Services */}
      <div className="text-center mb-5">
        <h2 style={sectionStyle}>🔌 Our Repair Services</h2>
        <p className="lead">
          Expert repair services for all your essential home appliances.
        </p>
      </div>

      <div className="row">
        {services.map((service, index) => (
          <div className="col-md-6 col-lg-4 mb-4" key={index} data-aos="zoom-in">
            <div className="card h-100 shadow-sm">
              <img
  src={service.image}
  className="card-img-top img-fluid"
  alt={service.title}
  style={{ height: '200px', objectFit: 'cover' }}
/>

              <div className="card-body bg-white">
                <h5 className="card-title text-dark">{service.title}</h5>
                <ul className="list-unstyled text-dark">
                  {service.features.map((item, idx) => (
                    <li key={idx}>• {item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* About Us */}
      <section className="my-5 p-4 text-white rounded shadow-sm">
        <h2 className="text-center mb-3" style={sectionStyle}>🏠 About Our Company</h2>
        <p>
          With over 10+ years of experience, we are a locally trusted appliance repair service known
          for reliable repairs and customer satisfaction. Our mission is to deliver quick, affordable,
          and long-lasting repair services to every household in <strong>Your City/Region</strong>.
        </p>
        <p>
          Our team of certified technicians handles everything from minor faults to complex repairs —
          all with genuine parts and upfront pricing.
        </p>
      </section>

      {/* Why Choose Us */}
      <div className="mt-5">
        <h2 style={sectionStyle}>💡 Why Choose Our Appliance Repair Experts?</h2>
        <ul>
          <li>Trained & certified technicians</li>
          <li>Quick diagnosis and transparent pricing</li>
          <li>Genuine spare parts</li>
          <li>Same-day service available</li>
          <li>Warranty on all repairs</li>
        </ul>
      </div>

      {/* How It Works */}
      <section className="my-5">
        <h2 className="text-center mb-4" style={sectionStyle}>🔧 How It Works</h2>
        <div className="row text-center">
          <div className="col-md-3">
            <h5>1. Request Service</h5>
            <p>Call or book online in seconds</p>
          </div>
          <div className="col-md-3">
            <h5>2. Get Technician</h5>
            <p>Certified experts at your doorstep</p>
          </div>
          <div className="col-md-3">
            <h5>3. Diagnose & Repair</h5>
            <p>Quick, transparent & reliable repair</p>
          </div>
          <div className="col-md-3">
            <h5>4. Enjoy Peace of Mind</h5>
            <p>Warranty-backed services</p>
          </div>
        </div>
      </section>

      {/* Service Areas */}
      <div className="mt-4">
        <h2 style={sectionStyle}>📍 Service Areas</h2>
        <p>We proudly serve <strong>Siwan/Region</strong> and surrounding locations.</p>
      </div>

      {/* FAQ Section */}
      <div className="mt-5">
        <h3 style={sectionStyle}>❓ Frequently Asked Questions</h3>
        <div className="accordion" id="faqAccordion">
          {faqs.map((faq, index) => (
            <div className="card my-2" key={index}>
              <div
                className="card-header"
                style={{ cursor: 'pointer', backgroundColor: '#f1f1f1' }}
                onClick={() => toggleFAQ(index)}
              >
                <h5 className="mb-0 d-flex justify-content-between align-items-center">
                  {faq.question}
                  <span>{openIndex === index ? '−' : '+'}</span>
                </h5>
              </div>
              {openIndex === index && (
                <div className="card-body" style={{ backgroundColor: 'white', color: '#333' }}>
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Contact Section */}
      <div className="mt-5 text-center p-4 text-white rounded">
        <h3 style={sectionStyle}>📞 Need Immediate Help?</h3>
        <p>
          Call us at <strong><a href="tel:+919199245536" className="text-warning">9199245536</a></strong> or{' '}
          <a href="/contact" className="text-info">submit a repair request</a> to get started.
        </p>
      </div>
    </div>
  );
};

export default HomeApplianceService;
